export default "__VITE_ASSET__390778f8__"